<template>
    <div v-loading="loading">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 class="header">收银台</h1>
                    <div style="width: 100%; height: 5px; background-color: red;"></div>
                    <div class="header-content">
                        <span>支付金额: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span style="font-size: 20px;color: red;">￥{{ course.price }}</span>
                        <span style="padding-left: 450px;">购买单号:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span>{{ id }}</span>
                    </div>
                </div>
                <div class="col-12 body-head">
                    <div>
                        <div @click="change">
                            <img width="120px" height="60px" src="https://gw.alipayobjects.com/zos/bmw-prod/f466695f-f426-4e79-ae69-ecdf64a03c71.svg" alt="">
                        </div>
                        <div v-show="select"><i style="font-size: 30px; font-weight: 600; color: red; padding-left: 35px;" class="el-icon-check"></i></div>
                    </div>
                </div>
                <div class="col-12"><el-divider></el-divider><el-divider></el-divider></div>
                <div class="col-12">
                    <div style="padding-left: 10px;">
                        推荐支付宝扫码支付
                    </div>
                    <el-button style="margin-top: 20px; margin-left: 10px;" type="primary" @click="toPay">去支付页面</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'
    import { nanoid } from 'nanoid'
    export default {
        name:'Consume',
        data() {
            return {
                select:true,// 1 支付宝 0微信

                idd:'',
                id: '',

                course:{},
                loading: true,
            }
        },
        created() {
            const vue = this
            const route = this.$route
            $.ajax({
                url:'https://app6132.acapp.acwing.com.cn/api/course/read/one/',
                type:'get',
                data: {
                    id:route.params.id
                },
                success(resp) {
                    if (resp.error_message === 'success') {
                        
                        const course = JSON.parse(resp.course)
                        console.log(course)
                        vue.course = course
                        vue.loading = false
                    } 
                },
            })
        },
        mounted() {
            this.idd = "A" + nanoid() + "L"

            if (this.$store.state.me.id !== "") this.readOrder()
            else {
                const t = setInterval(() => {
                    if (this.$store.state.me.id !== "") {
                        this.readOrder()
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }
        },
        methods: {
            toPay() {
                window.open(
                    'https://app6132.acapp.acwing.com.cn/api/alipay/pay?subject=' + this.course.courseName + '&traceNo=' + this.id + '&totalAmount=' + this.course.price
                )
            },
            change() {
                this.select = !this.select
            },
            readOrder() {
                const vue = this
                const route = this.$route
                const store = this.$store
                $.ajax({
                    url: Url.rOrderUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    data: {
                        courseId: route.params.id
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.id = JSON.parse(resp.order).orderId
                        } else {
                            vue.id = route.params.id + vue.idd + store.state.me.id
                        }
                    },
                    error(resp) {
                        vue.id = route.params.id + vue.idd + store.state.me.id
                    }
                })
            }
        }
    }
</script>

<style scoped>
.body-head {
    padding: 40px;
    min-height: 120px;
    display: flex;
}
.header {
    height: 60px;
    line-height: 60px;
    padding-left: 200px;
    font-size: 30px;
}
.header-content {
    background-color: #F5F5F5;
    width: 100%;
    min-height: 60px;
    height: auto;
    line-height: 60px;
    font-size: 16px;
    padding-left: 80px;
    color: grey;
}
</style>